module.exports = __webpack_public_path__ + "static/img/ic-top-innovate.ad76e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-top-innovate.png
// module id = aid2
// module chunks = 1